import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { DataMainTemplate } from "@nocios/presentation-kit";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import AnimtionLeftPanelBlue from "src/Component/AnimtionLeftPanelBlue";
import ChatMessageAnimation from "../../Component/ChatMessageAnimation";
import DualList from "../../Component/DualList";

// Constants
const PAGE_ID = 5;
const BG_ID = 5;
const BG_TYPE = "jpg";
const NEXT_PAGE_ID = PAGE_ID + 1;
const BACK_PAGE_ID = PAGE_ID - 1;

const LEFT_TITLE = "Negative customer\nand agent experience";

// Main data function that returns the template data
const DATA = (): DataMainTemplate => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const currentPage = useSelector(
    (state: { appReducer: { currentPage: number } }) =>
      state.appReducer.currentPage
  );

  const baseImageBG = `${Config.BASE_URL}/images/BG/`;

  const backButton =
    BACK_PAGE_ID > 0
      ? {
          label: "Back",
          type: "back" as const,
          startIcon: { icon: "arrow-right", color: "#fff" },
          onClick: () => setCurrentPage(BACK_PAGE_ID),
          style: {
            borderRadius: "45px",
            padding: "var(--width-5) var(--width-25)",
            gap: "var(--width-16)",
          },
        }
      : undefined;

  const nextButton = {
    label: "Next",
    type: "next" as const,
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NEXT_PAGE_ID),
    style: {
      borderRadius: "45px",
      padding: "var(--width-5) var(--width-25)",
      gap: "var(--width-16)",
    },
  };

  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (PAGE_ID === currentPage) {
      if (videoRef.current) videoRef.current.play();

      timer = setTimeout(() => {
        setStartAnimation(true);
      }, 100);
    } else {
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }

      setStartAnimation(false);
    }

    return () => clearTimeout(timer);
  }, [currentPage]);

  return {
    styleBody: { marginTop: 0 },
    bgImage: `${baseImageBG}BG_${BG_ID}.${BG_TYPE}`,
    title: LEFT_TITLE,
    leftAfterTitle: (
      <DualList
        pageId={PAGE_ID}
        topPersonName="martina"
        topListTitle="Customer"
        topListItems={[
          "Wasted Time",
          "Frustration and Dissatisfaction",
          "Lack of Communication",
          "Inconvenience",
        ]}
        bottomPersonName="sarah"
        bottomListTitle="Customer Support Representative (CSR)"
        bottomListItems={[
          "Handling Angry Customers",
          "Swivel chair causing Lack of Information",
          "Increased Call Volume",
          "Negative Performance Metrics",
        ]}
      />
    ),
    leftAfterDescription: (
      <AnimtionLeftPanelBlue
        style={{
          left: "calc(-1 * var(--width-102))",
          width: "var(--width-792)",
          top: "var(--height-20)",
        }}
        startAnimation={startAnimation}
        image={`${Config.BASE_URL}/images/screen_${PAGE_ID}/left_0.png`}
      />
    ),
    rightSideComponent: (
      <ChatMessageAnimation
        startAnimation={startAnimation}
        baseImagePath={`${Config.BASE_URL}/images/screen_${PAGE_ID}/right_`}
        containerStyle={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
        chatWidth="var(--width-700)" // Width of the chat container
        verticalSpacing="2%" // Less space between messages
        maxWidth="var(--width-800)" // Maximum width of each message
        scaleArray={[1, 1, 1, 1, 1, 1]}
        transformPositionX="20%"
        transformPositionY="-15%"
        // New properties for scroll functionality
        enableScroll={true} // Enable the scroll functionality
        scrollThreshold={5} // Start scrolling after 3 messages
      />
    ),
    next: nextButton,
    back: backButton,
  };
};

export default DATA;
